import React from "react";
import { motion } from "framer-motion";
import { Panel } from "@/components/common/Panel";
import { SeverityBadge, StatusBadge, ConfidenceMeter } from "@/components/common/Badges";
import { TID } from "@/lib/testIds";

export function RecommendationsTab({ recs, setOpenRec }) {
    return (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
            {recs.length === 0 && <Panel className="lg:col-span-2" eyebrow="Empty" title="No recommendations yet"><p className="text-sm text-slate-400">Run analysis to generate explainable recommendations.</p></Panel>}
            {recs.map((r) => (
                <motion.button
                    key={r.id}
                    data-testid={TID.recommendationCard(r.id)}
                    onClick={() => setOpenRec(r)}
                    whileHover={{ y: -2 }}
                    className="panel-elevated text-left p-5 hover:border-cyan-500/30 transition-colors group"
                >
                    <div className="flex items-start justify-between gap-3">
                        <SeverityBadge severity={r.risk_rating} />
                        <StatusBadge status={r.status} />
                    </div>
                    <h3 className="font-display text-lg text-white mt-3">{r.title}</h3>
                    <p className="text-xs text-slate-400 mt-2 line-clamp-3">{r.root_cause}</p>
                    <div className="flex items-center justify-between mt-4">
                        <ConfidenceMeter value={r.confidence_score} />
                        <div className="text-[10px] font-mono uppercase text-slate-500">Effort · {r.estimated_effort}</div>
                    </div>
                </motion.button>
            ))}
        </div>
    );
}
